import axios from 'axios'
import qs from 'qs'
import store from '@/store'
import router from '../router'

axios.defaults.timeout = 50000
axios.defaults.baseURL = ''
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, params = {},headers = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
        params: params,
        headers:headers
      })
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}, head = {}) {
  let params = {
    version: '1.0.0'
  }
  if(store && store.state && store.state.common){
    params.openId = store.state.common.openId
    params.userId = store.state.common.userId
    params.cityId = store.state.common.marketInfo.cityId || ''
    params.marketId = store.state.common.marketInfo.id || ''
    params.memberCode = store.state.common.userInfo.memberCode || ''
  }
  params = {
    ...params,
    ...head
  }
  return new Promise((resolve, reject) => {
    axios.post(url, qs.stringify({
      'data': "{'head':" + JSON.stringify(params) + ",'body':" + JSON.stringify(data) + '}'
    })).then(response => {
      if (response.data.res){
        switch (response.data.res.code) {
          case 10004:
            if (
              url.indexOf("buryingPoint/add") > -1 ||
              url.indexOf("mbMaskingAdsApi/getMaskingAds") > -1
            ) {
              console.log("in buryingPoint/add"); //统计接口 不跳登录
            } else {
               console.log("in 登出 " +url); //统计接口 不跳登录
              router.push({
                path: "/login"
              });
            }
            break;
          default:
            resolve(response.data);
        }
      }
      resolve(response.data)
    }).catch(err => {
      reject(err)
    })
  })
}
export function postEwm(url, data = {}, come) {
  let mess = JSON.stringify(data)
  if(come === 'meeting'){
    mess = JSON.stringify(data).replace(/(\")/g,"\\$1")
  }
  return new Promise((resolve, reject) => {
    axios.post(url, qs.stringify({
      'data': mess
    })).then(response => {
      resolve(response.data)
    }, err => {
      reject(err)
    }).catch(e=>{
      console.log(e)
    })
  })
}
export function postIBP(url, data = {}, head = '') {
  return new Promise((resolve, reject) => {
    axios.post(url, qs.stringify({
      'data': "{'header':{'channel':'starAppPayment','version':'1.0.0'," + head + "},'body':{" + data + '}}'
    })).then(response => {
      resolve(response.data)
    }, err => {
      reject(err)
    })
  })
}

export function postArr(url, data = {}, head = '') {
  return new Promise((resolve, reject) => {
    axios.post(url, qs.stringify({
      'data': "{'head':{'version':'1.0.0'," + head + "},'body':" + data + '}'
    })).then(response => {
      resolve(response.data)
    }, err => {
      reject(err)
    })
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function postEr(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, qs.stringify({
      'data': data
    })).then(response => {
      resolve(response.data)
    }, err => {
      reject(err)
    })
  })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data)
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data)
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
  })
}


export function fetch(method, url, params={},headers={}) {
  let header = {
    "Content-Type": "application/json",
    "Access-channel": "saas_h5"
  }
  header = {...header,...headers}
  return new Promise((resolve, reject) => {
    axios({
        method: method,
        url: url,
        headers: header,
        params: params,
        data:params,
      }).then(function(response) {
        resolve(response.data)
      })
      .catch(function(error) {
        reject(error)
      });
  })
}
export function fetchPost(method, url, params={},headers={}) {
  let header = {
    "Content-Type": "application/json",
    "Access-channel": "saas_h5"
  }
  header = {...header,...headers}
  return new Promise((resolve, reject) => {
    axios({
        method: method,
        url: url,
        headers: header,
        data:params,
      }).then(function(response) {
        resolve(response.data)
      })
      .catch(function(error) {
        reject(error)
      });
  })
}